const APP_CONFIG = {
  version: "7.81.0",
  title: "Claire V7.81.0",
  version_client: "7.81.0",
};

export default APP_CONFIG;
